import { AfterViewInit, Component, EventEmitter, Input } from '@angular/core';
import { IModalComponent } from '@lib/modal';
import { monitorLogger } from 'src/app/project/monitor/monitor-logger';

type RatingResult = {
  rating: number;
  review?: string;
  is_anonymous: boolean;
};

@Component({
  selector: 'app-modal-doctor-rating',
  templateUrl: './modal-doctor-rating.component.html',
  styleUrls: ['./modal-doctor-rating.component.scss'],
})
export class ModalDoctorRatingComponent implements IModalComponent<RatingResult>, AfterViewInit {
  @Input() isLoading = false;

  public submit$ = new EventEmitter<RatingResult>();
  public close$ = new EventEmitter<any>();

  public doctorRating: RatingResult = {
    rating: 0,
    review: '',
    is_anonymous: false,
  };

  public MAX_REVIEW_LENGTH = 292;

  ngAfterViewInit(): void {
    monitorLogger.screen.trackScreen('avaliar-medico', 'tela_avaliar_medico');
  }

  public closeModal() {
    monitorLogger.screen.trackScreen('modal-doctor-rating', 'clicar_botao_cancelar_rating');
    this.close$.emit();
  }

  public submitRating() {
    monitorLogger.screen.trackScreen('modal-doctor-rating', 'clicar_botao_enviar_rating');
    this.submit$.emit(this.doctorRating);
  }

  public onAnonymousClick() {
    monitorLogger.screen.trackScreen('modal-doctor-rating', 'clicar_checkbox_anonimo_medico');
  }

  public onStarClick() {
    monitorLogger.screen.trackScreen('modal-doctor-rating', 'clicar_icone_classificar_estrela_medico');
  }
}
